<div class="close-btn" (click)="dismiss()">
  <ion-icon name="close"></ion-icon>
</div>
<!-- Content -->
<ion-content scrollY="true">
  <ng-container *ngIf="!liked; else supportedCampaign">
    <img src="/assets/images/support.gif" />
    <div class="about">
      <h1>{{'IMPACT.publicisCampaign.confirmationModal.title' | translate}}</h1>
      <div
        class="content"
        [innerHTML]="(shareholder ? 'IMPACT.publicisCampaign.confirmationModal.description.shareholder' : 'IMPACT.publicisCampaign.confirmationModal.description.notShareholder') | translate"
      ></div>
    </div>
    <div *ngIf="!shareholder" class="checkbox" (click)="rebalance()">
      <ion-icon [name]="'checkbox-' + (rebalanceAgreed ? 'off':'on')"></ion-icon>
      <p>{{'IMPACT.publicisCampaign.confirmationModal.rebalance' | translate}}</p>
    </div>
    <div class="sticky-button">
      <button (click)="supportCampaign()" [disabled]="!shareholder && !rebalanceAgreed" [ngClass]="{loading: isLoading}">
        <ion-icon name="inyova" class="loading-icon"></ion-icon>
        {{'IMPACT.publicisCampaign.confirmationModal.button.confirm' | translate}}
      </button>
    </div>
  </ng-container>
  <ng-template #supportedCampaign>
    <img src="/assets/images/thank-you.gif" />
    <div class="about">
      <h1>{{'IMPACT.publicisCampaign.confirmationModal.thanks.title' | translate}}</h1>
      <p>
        <span
          [innerHTML]="'IMPACT.publicisCampaign.confirmationModal.thanks.description'| translate"
          [ngClass]="{'hide-unsupport': expired }"
          class="support-desc"
        ></span>
        <a href="javascript:;" (click)="unsupportCampaign()" *ngIf="!expired">
          {{'IMPACT.publicisCampaign.confirmationModal.thanks.unsupport'| translate}}
        </a>
      </p>
    </div>
    <button (click)="shareCampaign()">
      {{ (!expired ? 'IMPACT.publicisCampaign.button.invite.ongoing' : 'IMPACT.publicisCampaign.button.invite.finished') | translate }}
    </button>
  </ng-template>
</ion-content>
